import { reducer as appReducer } from './app/slice'
import { reducer as authenticationReducer } from './authentication/slice'
import { reducer as modalReducer } from './modal/slice'
import { reducer as mqttReducer } from './mqtt/slice'
import { reducer as serversReducer } from './servers/slice'
import { reducer as notificationsReducer } from './notifications/slice'
import { reducer as uiReducer } from './ui/slice'
import { routerReducer } from './router/reducer'

import {
  authApi,
  daemon,
  managementApi,
  matchTrackerApi,
  metricsServerApi,
  sportscasterApi,
  staticAssetApi,
  streamingApi,
  reportingApi
} from './servers/api'

export const moduleReducers = {
  app: appReducer,
  authentication: authenticationReducer,
  modal: modalReducer,
  mqtt: mqttReducer,
  servers: serversReducer,
  notifications: notificationsReducer,
  router: routerReducer,
  ui: uiReducer,

  [metricsServerApi.reducerPath]: metricsServerApi.reducer,
  [matchTrackerApi.reducerPath]: matchTrackerApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [daemon.reducerPath]: daemon.reducer,
  [managementApi.reducerPath]: managementApi.reducer,
  [sportscasterApi.reducerPath]: sportscasterApi.reducer,
  [staticAssetApi.reducerPath]: staticAssetApi.reducer,
  [streamingApi.reducerPath]: streamingApi.reducer,
  [reportingApi.reducerPath]: reportingApi.reducer
}

// API Middleware //
export const moduleApiMiddlewares = [
  authApi.middleware,
  metricsServerApi.middleware,
  matchTrackerApi.middleware,
  daemon.middleware,
  managementApi.middleware,
  sportscasterApi.middleware,
  staticAssetApi.middleware,
  streamingApi.middleware,
  reportingApi.middleware
]

// Module Exports //
export * from './servers'
